
var React =              require("react");
var CardActionItem   = require("./generic/CardActionItem.jsx");
var CircuitsUtil       = require("./../../util/CircuitsUtil.js");
var DataActionUtil       = require("./../../util/DataActionUtil.js");

class ExportPackageButton extends React.Component {

    constructor() {
        super();    
    }
    
  
    render() {
        return <CardActionItem
                    {...this.props}
                    text="Export"
                    iconText={
                        <React.Fragment>
                             <svg width="16" height="18" xmlns="http://www.w3.org/2000/svg">
                                 <use xlinkHref='#export' />
                             </svg>
                         </React.Fragment>
                    }
                    tooltip="Export as LBR"
                    action={DataActionUtil.exportAsset}
                    reasonDisabled="Missing a version"
                    disabled={CircuitsUtil.getMostRecentVersion(this.props.resource) === -1}
                    addedClass="gridButton"/>
    }

}

module.exports = ExportPackageButton;
